import React from "react";
import { Modal, Button } from "antd";
import { Check } from "lucide-react";
import { useNavigate } from "react-router-dom";

const JoinTournamentModal = ({ open, onClose, data, profile, onJoin }) => {
  const navigate = useNavigate();

  if (!data) return null;
  // Safely handle missing entryFee/token from tournament data (e.g. when fields are commented out)
  const entryFee = Number(data?.entryFee) || 0;
  const tokenLabel = data?.token ?? "Tokens";
  const balance = Number(profile?.balance) || 0;
  const hasEnoughBalance = balance >= entryFee;

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      centered
      className="join-upcoming-tournament-modal"
    >
      <div className="join-upcoming-tournament-wrapper">
        <div className="join-upcoming-tournament-icon">
          <Check />
        </div>

        <h2 className="join-upcoming-tournament-title">
          {hasEnoughBalance ? "Join Tournament" : "Insufficient Tokens"}
        </h2>

        {hasEnoughBalance ? (
          <p className="join-upcoming-tournament-desc">
            {entryFee > 0 ? (
              <>
                Entry Fee:{" "}
                <strong>
                  {entryFee} {tokenLabel}
                </strong>
                <br />
                {tokenLabel} will be deducted automatically.
              </>
            ) : (
              <>This tournament is free to join.</>
            )}
          </p>
        ) : (
          <p className="join-upcoming-tournament-desc error">
            You don’t have sufficient tokens to play this match.
          </p>
        )}

        <div className="join-upcoming-tournament-info">
          <div>
            <span>Your Balance</span>
            <strong>
              {balance.toFixed(2)} {tokenLabel}
            </strong>
          </div>
          <div>
            <span>Entry Fee</span>
            <strong>
              {entryFee} {tokenLabel}
            </strong>
          </div>
        </div>

        <div className="join-upcoming-tournament-actions">
          <Button
            className="join-upcoming-tournament-back-btn Fill-button"
            onClick={onClose}
          >
            Back
          </Button>

          {hasEnoughBalance ? (
            <Button
              className="join-upcoming-tournament-join-btn Fill-button"
              onClick={() => {
                onJoin(data._id); // 🔥 REGISTER API CALL
                onClose();
              }}
            >
              Join
            </Button>
          ) : (
            <Button
              className="join-upcoming-tournament-buy-btn Fill-button"
              onClick={() => {
                onClose();
                navigate("/wallet/buy-token");
              }}
            >
              Buy Tokens
            </Button>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default JoinTournamentModal;
